<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Page Header -->
      <breadcrumbthree :title="title" :text="text" :text1="text1" />
      <!-- /Page Header -->


      <div class="row">
        <div class="col-sm-12">
          <VCard>
            <VCardText>
              <h3 >Bienvenido {{ usuario.nombres }}</h3>
              <h5>Email: {{ usuario.email }}</h5>
            </VCardText>
          </VCard>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>

<script>

import { router } from "@/router";

export default {
  data() {
    return {
      title: "Bienvenido",
      text: "Menú",
      text1: "Bienvenido",
      usuario: {
        nombres: "",
        username: "",
        email: "",
      }
    };
  },
  beforeRouteEnter(to, from, next){
    if (!localStorage.getItem('userDataAdmin')) {
      router.push('/admin/login');
    }else{
      next()
    }
  },
  mounted() {
    this.usuario = JSON.parse( localStorage.getItem("userDataAdmin") );
  }
};
</script>
